"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var getIcon_1 = __importDefault(require("@empiriecom/module-components/utils/getIcon"));
var react_intl_1 = require("react-intl");
var useConfig_1 = __importDefault(require("../../hooks/useConfig"));
var StyledTeaser = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: none;\n  max-width: 25rem;\n  left: 0;\n  right: 0;\n  margin: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: -0.125rem;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  background-color: ", ";\n  padding: 0.563rem 0.625rem 0.188rem 1.063rem;\n  color: ", ";\n  cursor: pointer;\n\n  svg {\n    widht: 2rem;\n    height: 2rem;\n    color: ", ";\n  }\n\n  @media only screen and (max-width: ", ") {\n    max-width: initial;\n    width: 100%;\n    border-top: 0.125rem solid ", ";\n    border-bottom: 0.19rem solid ", ";\n    background-color: ", ";\n    color: ", ";\n    background-image: none;\n    svg {\n      color: ", ";\n    }\n  }\n\n  span {\n    text-align: left;\n    flex-grow: 1;\n    margin: 0 0.5rem;\n  }\n"], ["\n  border: none;\n  max-width: 25rem;\n  left: 0;\n  right: 0;\n  margin: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: -0.125rem;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  background-color: ", ";\n  padding: 0.563rem 0.625rem 0.188rem 1.063rem;\n  color: ", ";\n  cursor: pointer;\n\n  svg {\n    widht: 2rem;\n    height: 2rem;\n    color: ", ";\n  }\n\n  @media only screen and (max-width: ",
    ") {\n    max-width: initial;\n    width: 100%;\n    border-top: 0.125rem solid ", ";\n    border-bottom: 0.19rem solid ", ";\n    background-color: ", ";\n    color: ", ";\n    background-image: none;\n    svg {\n      color: ", ";\n    }\n  }\n\n  span {\n    text-align: left;\n    flex-grow: 1;\n    margin: 0 0.5rem;\n  }\n"])), function (_a) {
    var primary = _a.theme.primary;
    return primary.color.normal;
}, function (_a) {
    var primary = _a.theme.primary;
    return primary.color.text;
}, function (_a) {
    var primary = _a.theme.primary;
    return primary.color.text;
}, function (_a) {
    var desktopminwidth = _a.desktopminwidth;
    return desktopminwidth;
}, function (_a) {
    var primary = _a.theme.primary;
    return primary.color.normal;
}, function (_a) {
    var greyNormal = _a.theme.greyNormal;
    return greyNormal.color.normal;
}, function (_a) {
    var greyLight = _a.theme.greyLight;
    return greyLight.color.normal;
}, function (_a) {
    var global = _a.theme.global;
    return global.color.textDark;
}, function (_a) {
    var global = _a.theme.global;
    return global.color.textDark;
});
var Teaser = function (_a) {
    var _b, _c;
    var onTeaserClick = _a.onTeaserClick, onCloseIconClick = _a.onCloseIconClick;
    var config = useConfig_1.default();
    var CloseIcon = getIcon_1.default('Cancel');
    var MailIcon = getIcon_1.default('Mail');
    return (react_1.default.createElement(StyledTeaser, { "data-testid": "teaser", desktopminwidth: (_c = (_b = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c.desktopMinWidth, onClick: onTeaserClick, size: "large", noRipple: "true", layout: "primary" },
        react_1.default.createElement(MailIcon, null),
        react_1.default.createElement("span", null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "nlSheet.teaser", defaultMessage: "{content}" })),
        react_1.default.createElement("div", { "data-testid": "closeBtn", role: "button", onKeyPress: onCloseIconClick, onClick: onCloseIconClick, tabIndex: 0 },
            react_1.default.createElement(CloseIcon, null))));
};
exports.default = Teaser;
var templateObject_1;
//# sourceMappingURL=Teaser.js.map